export class SSORedirectHelper {

  private static containsQuestionMark(s: string): boolean {
    return s.indexOf('?') !== -1;
  }

  public static withReturnUrl(url: string, returnUrl: string, query: string): string {
    let updatedQuery = query || '';
    if (SSORedirectHelper.containsQuestionMark(returnUrl)
      && SSORedirectHelper.containsQuestionMark(query)) {
      updatedQuery = `&${query.substring(1, query.length)}`;
    }

    let updatedReturnUrl = returnUrl || '';
    if (returnUrl.indexOf('https://') > -1) {
      updatedReturnUrl = returnUrl.substring('https://'.length);
    } else if (returnUrl.indexOf('http://') > -1) {
      updatedReturnUrl = returnUrl.substring('http://'.length);
    }

    return `${url}?destination=${encodeURIComponent(updatedReturnUrl + updatedQuery)}`;
  }
}
